import { createTheme } from "@mui/material/styles";

const theme = createTheme({

    typography: {
        fontFamily: "Archivo, Arial, sans-serif",

        h1:{
            fontWeight:900,
        },

        h2:{
            fontWeight:700,
        },

        h3:{
            fontWeight:700,
        },

        button:{
            fontWeight:600,
            textTransform:"none",
        },

        body1:{
            fontWeight:400,
        }
    }

});

export default theme;
